import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"; // Agregado para el estilo de slick
import './HeroCarousel.css';

// URLs públicas de las imágenes AVIF en S3 (placeholders)
const imgCampoPlaceholder = 'https://pascolo-react-2026.s3.sa-east-1.amazonaws.com/static/media/ver_productos.1c9cf5f1669311d0ad59.avif';
const imgQuienesPlaceholder = 'https://pascolo-react-2026.s3.sa-east-1.amazonaws.com/static/media/quienes_somos.4c0e0ea4c3545f14d8ec.avif';
const imgProduccionPlaceholder = 'https://pascolo-react-2026.s3.sa-east-1.amazonaws.com/static/media/como_producimos.0b37808e9f12884b0eff.avif';

// Imágenes reales (JPG) en S3
const imgCampo = 'https://pascolo-react-2026.s3.sa-east-1.amazonaws.com/static/media/ver_productos.2d9edb3458fbaf2154cb.jpg';
const imgQuienes = 'https://pascolo-react-2026.s3.sa-east-1.amazonaws.com/static/media/quienes_somos.ad186dd2cc0548c685e2.jpg';
const imgProduccion = 'https://pascolo-react-2026.s3.sa-east-1.amazonaws.com/static/media/como_producimos.aa0e608c82e3859f7171.jpg';

// Datos para el carrousel
const slidesData = [
  {
    id: 1,
    placeholder: imgCampoPlaceholder,
    real: imgCampo,
    titulo: 'Páscolo: Quesos de Tambo Propios',
    subtitulo: 'Productos naturales, sin aditivos',
    botonTexto: 'Ver Productos',
    link: '/productos'
  },
  {
    id: 2,
    placeholder: imgQuienesPlaceholder,
    real: imgQuienes,
    titulo: 'Nuestra Historia',
    subtitulo: 'Conocé quiénes somos y por qué elegimos la elaboración artesanal.',
    botonTexto: 'Quiénes Somos',
    link: '/quienes-somos'
  },
  {
    id: 3,
    placeholder: imgProduccionPlaceholder,
    real: imgProduccion,
    titulo: 'Así Elaboramos Nuestros Productos',
    subtitulo: 'Un recorrido por nuestro proceso, desde el ordeñe hasta la maduración.',
    botonTexto: 'Cómo Producimos',
    link: '/como-producimos'
  }
];

// Flechas personalizadas
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow slick-next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow slick-prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const HeroCarousel = () => {
  useEffect(() => {
    console.log("AVIF test:", new Image().src = slidesData[0].placeholder);
  }, []);

  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (id) => {
    setLoadedImages(prev => ({ ...prev, [id]: true }));
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => <div className="slick-dots-container"><ul>{dots}</ul></div>,
    lazyLoad: 'ondemand',
  };

  return (
    <div className="hero-carousel-container">
      <Slider {...settings}>
        {slidesData.map((slide) => (
          <div key={slide.id} className="slick-slide-item">
            {/* Real Image - JPG */}
            <img
              src={slide.real}
              alt={slide.titulo}
              className="slide-image real"
              width={1200}
              height={600}
              loading={slide.id === 1 ? "eager" : "lazy"}
            />
            
            {/* AVIF as background image with blur effect */}
            <div
              className="slide-placeholder"
              style={{
                backgroundImage: `url(${slide.placeholder})`,
                backgroundSize: 'cover',
                filter: 'blur(25px)',
                transform: 'scale(1.1)',
              }}
            />

            <div className="slide-overlay" />
            <div className="slide-content">
              <h1>{slide.titulo}</h1>
              <p>{slide.subtitulo}</p>
              <Link to={slide.link} className="slide-btn">
                {slide.botonTexto}
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroCarousel;